<div class="wizard-container">
    <div class="top-section">
        <div class="wizard-header">
            <div class="image-container">
                <img class="wizard-logo" [src]="'svg/strategy-deck.svg' | assetVersion" [style.--svg-url]="'url(' + 'svg/strategy-deck.svg' + ')'">
            </div>
            <div class="wizard-text-content">
                <div class="wizard-title">Strategy Deck</div>
                <div class="wizard-description">Create a comprehensive strategy deck for your brand.</div>
            </div>
        </div>
    </div>
    <div class="content-section">
        @if (isLoading()) {
            <div class="loading-container">
                <app-spinner-icon class="deck-spinner"></app-spinner-icon>
                <div class="section-title">Generating your Strategy Deck...</div>
                <div class="section-description">This may take a moment while we gather and compile your data.</div>
            </div>
        } @else {
            <div class="title-container">
                <div class="section-title">Build your Strategy Deck</div>
                <div class="section-description">Choose your brand, competitors, and the sections you'd like to include.</div>
            </div>
            <form [formGroup]="wizardForm" class="wizard-form">

                <div class="form-section">
                    <div class="logo-label-container">
                        <img [src]="'svg/grey-brand.svg' | assetVersion">
                        <label class="form-label">My Brand</label>
                    </div>
                    <app-select-menu
                        [control]="brandsControl" [items]="brandOptions()" [searchable]="brandOptions().length > 6"
                        [width]="'100%'" [placeholder]="'Select a brand'" [selectMode]="SelectMode.SINGLE"
                        [showSelectedIcon]="true">
                    </app-select-menu>
                </div>

                <div class="form-section">
                    <div class="logo-label-container">
                        <img [src]="'svg/competitors.svg' | assetVersion">
                        <label class="form-label">Competitors</label>
                        <span class="form-hint">(up to 5)</span>
                    </div>
                    <app-select-menu
                        [control]="competitorsControl" [items]="competitorOptions()" [searchable]="competitorOptions().length > 6"
                        [disabled]="!brandsControl.value || competitorOptions().length === 0"
                        [width]="'100%'" [placeholder]="brandsControl.value ? 'Select competitors' : 'Select a brand first'"
                        [selectMode]="SelectMode.MULTI" [selectAllAndClearOptions]="showSelectAllOption()" [showAllSelectedIcons]="true"
                        [maxSelectedItems]="5">
                    </app-select-menu>
                </div>

                <div class="form-section">
                    <div class="logo-label-container">
                        <label class="form-label">Deck Content</label>
                    </div>
                    <div class="deck-content-container">
                        @for (content of deckContentValues; track content) {
                            <div class="deck-content-item" [class.selected]="deckContentControl.value.includes(content)" (click)="deckContentClicked(content)">
                                <img [src]="'svg/plus-gray.svg' | assetVersion">
                                <div class="deck-content-item-title">{{ content }}</div>
                            </div>
                        }
                    </div>
                </div>

                <div class="form-section">
                    <div class="logo-label-container">
                        <img [src]="'svg/calendar.svg' | assetVersion">
                        <label class="form-label">Date Range</label>
                    </div>
                    <div [matTooltip]="tooltips.strategyDeck.dateRange" matTooltipClass="tooltip-with-triangle" matTooltipPosition="below">
                        <app-select-menu
                            [disabled]="true"
                            [selectMode]="SelectMode.SINGLE" [width]="'100%'" [placeholder]="'Last 30 days'"
                            [control]="dateRangeControl" [items]="dateRangeOptions()">
                        </app-select-menu>
                    </div>
                </div>

            </form>
        }
    </div>
    <div class="bottom-section">
        @if (!isLoading()) {
            <button class="previous-button" (click)="exit()"><img [src]="'svg/arrow-left.svg' | assetVersion"> Back</button>
            <button class="submit-button" [class.disabled]="!isFormValid" (click)="submit()">
                Generate with {{ polarisName }} <img [src]="'svg/ai-star-white.svg' | assetVersion">
            </button>
        } @else {
            <button class="previous-button" (click)="exit()"><img [src]="'svg/arrow-left.svg' | assetVersion"> Cancel</button>
        }
    </div>
</div>